import { GetStaticProps } from 'next';
import { NextSeo } from 'next-seo';
import dynamic from 'next/dynamic';
import React from 'react';

import { CDNAssets } from '../CDN';
import { ContactUsMode } from '../components/forms/ContactForm';
import HeaderSection, { HeaderSectionDestinationUrl } from '../components/layout/sections/HeaderSection';
import PageSection from '../components/layout/sections/PageSection';
import { StrapiApiClient } from '../lib/integrations/strapi/StrapiApiClient';
import { StrapiApiArticle } from '../lib/integrations/strapi/types';
import { withGlobalDefaultStaticProps } from '../lib/next-hooks/withGlobalDefaultStaticProps';
import { getPageSeoConfig } from '../lib/seo/pageSeoConfigs';
import pageRoutes from '../router/pageRoutes';
import { NextPageWithLayout } from '../types/global-types';
import ContactUsWidget from '../widgets/interactive/ContactUsWidget';

// Dynamically import with SSR disabled
const LearnMoreShowcase = dynamic(() => import('../widgets/showcases/LearnMoreShowcase'), { ssr: false });

type ContactUsPageStaticProps = {
  articles: StrapiApiArticle[];
};

export const getStaticProps: GetStaticProps<ContactUsPageStaticProps> = async (context) => {
  const articles = await StrapiApiClient.getRandomMostRecentArticles();
  const props: ContactUsPageStaticProps = { articles };
  return withGlobalDefaultStaticProps(context, { props });
};

// This is a comment to test a deployment

const ContactUsPage: NextPageWithLayout<ContactUsPageStaticProps> = (props) => {
  const { articles } = props;
  const seoConfig = getPageSeoConfig(pageRoutes.ContactUs);
  return (
    <>
      <NextSeo {...seoConfig} />
      <HeaderSection
        imageUrl={CDNAssets.getUrl('contact-page-hero')}
        title="Contact us"
        description="Let's talk about AI in employee support and answer your questions."
        destinationUrl={HeaderSectionDestinationUrl.ContactUs}
      />
      <PageSection isNarrowTop={true}>
        <ContactUsWidget defaultMode={ContactUsMode.Connect} showAllModes={false} />
      </PageSection>
      <PageSection>
        <LearnMoreShowcase articles={articles} />
      </PageSection>
    </>
  );
};
ContactUsPage.displayName = 'ContactUsPage';
export default ContactUsPage;
